import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.oralbook.details;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    LOAD_UNITS_ASYNC: `${uid}.loadUnitsAsync`,
    LOAD_UNITS_SUCCESS: `${uid}.loadUnitsSuccess`,
    LOAD_UNITS_FAILURE: `${uid}.loadUnitsFailure`,
    DELETE_SECTIONS_ASYNC: `${uid}.deleteSectionsAsync`,
    DELETE_SECTIONS_SUCCESS: `${uid}.deleteSectionsSuccess`,
    DELETE_SECTIONS_FAILURE: `${uid}.deleteSectionsFailure`,
    REORDER_SECTIONS_ASYNC: `${uid}.reorderSectionsAsync`,
    REORDER_SECTIONS_SUCCESS: `${uid}.reorderSectionsSuccess`,
    REORDER_SECTIONS_FAILURE: `${uid}.reorderectionsFailure`,
    DELETE_UNITS_ASYNC: `${uid}.deleteUnitsAsync`,
    DELETE_UNITS_SUCCESS: `${uid}.deleteUnitsSuccess`,
    DELETE_UNITS_FAILURE: `${uid}.deleteUnitsFailure`,
    REORDER_UNITS_ASYNC: `${uid}.reorderUnitsAsync`,
    REORDER_UNITS_SUCCESS: `${uid}.reorderUnitsSuccess`,
    REORDER_UNITS_FAILURE: `${uid}.reorderUnitsFailure`,
    SET_CURRENT_SECTION: `${uid}.setCurrentSection`,
    SELECT_SECTION: `${uid}.selectSection`,
    SELECT_UNIT: `${uid}.selectUnit`,
};

export { ActionTypes };
